// application
import enMessages from './messages/en.json';
import kmMessages from './messages/km.json';
import filMessages from './messages/fil.json';

export default {
    en: {
        messages: enMessages,
        direction: 'ltr',
    },
    km: {
        messages: kmMessages,
        direction: 'ltr',
    },
    fil: {
        messages: filMessages,
        direction: 'ltr',
    },
};
